export default "__VITE_ASSET__zJXadXJp__"